import React from 'react';

import { MastheadHeaderData } from 'lib/sanity/types';
import { NavBarLanguagePicker } from 'components/Masthead/Header/LanguagePicker';
import { SideMenuSecondaryLinks } from 'components/Masthead/Header/SideMenu/default/SecondaryLinks';
import { SideMenuPrimaryLinks } from 'components/Masthead/Header/SideMenu/default/PrimaryLinks';
import { SideMenuNavigationList } from 'components/Masthead/Header/SideMenu/Shared';

type Props = {
  headerEntry: MastheadHeaderData;
  closeBackdrop: () => void;
};

export const NavBarSideMenu = ({ headerEntry: { secondaryLinks, primaryLinks }, closeBackdrop }: Props) => {
  return (
    <>
      <SideMenuNavigationList $variant="default">
        <SideMenuSecondaryLinks secondaryLinks={secondaryLinks} closeBackdrop={closeBackdrop} />
        <SideMenuPrimaryLinks primaryLinks={primaryLinks} closeBackdrop={closeBackdrop} />
      </SideMenuNavigationList>
      <div>
        <NavBarLanguagePicker container="sidemenu" />
      </div>
    </>
  );
};
